import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { cloneElement, useEffect, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import Container from './container';
import styles from './modal.css';

function callOrReturn(ctx) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return typeof ctx === 'function' ? ctx.apply(void 0, args) : ctx;
}

function addClass(el, className) {
  var elClassName = el.className;

  if (!" ".concat(elClassName, " ").includes(" ".concat(className, " "))) {
    el.className += " ".concat(className);
  }
}

function removeClass(el, className) {
  var elClassName = el.className;

  if (" ".concat(elClassName, " ").includes(" ".concat(className, " "))) {
    el.className = " ".concat(elClassName, " ").replace(" ".concat(className, " "), '').trim();
  }
}

export default function Modal(_ref) {
  var content = _ref.content,
      children = _ref.children,
      forceIsShowing = _ref.forceIsShowing,
      onClose = _ref.onClose,
      onOpen = _ref.onOpen,
      rest = _objectWithoutProperties(_ref, ["content", "children", "forceIsShowing", "onClose", "onOpen"]);

  var _useState = useState(forceIsShowing),
      _useState2 = _slicedToArray(_useState, 2),
      isShowing = _useState2[0],
      setIsShowing = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      mounted = _useState4[0],
      setMounted = _useState4[1];

  var openModal = useCallback(function (e) {
    e.preventDefault();
    onOpen();
    setIsShowing(true);
  }, [onOpen]);
  var closeModal = useCallback(function (e) {
    e.preventDefault();
    onClose();
    setIsShowing(false);
  }, [onClose]);
  useEffect(function () {
    if (forceIsShowing) {
      onOpen();
    }

    setIsShowing(forceIsShowing);
  }, [forceIsShowing, onOpen]);
  useEffect(function () {
    setMounted(true);
    return function () {
      setMounted(false);
    };
  }, []);
  useEffect(function () {
    if (isShowing) {
      addClass(document.body, styles.noScroll);
    } else {
      removeClass(document.body, styles.noScroll);
    }
  }, [isShowing]);
  var renderProps = {
    close: closeModal,
    open: openModal
  };
  var renderedContent = callOrReturn(content, renderProps);
  var renderedChildren = callOrReturn(children, renderProps);

  var container = function container(containerChildren) {
    return React.createElement(Container, _extends({
      closeHandler: closeModal,
      isShowing: isShowing,
      key: "portal"
    }, rest), containerChildren);
  };

  var domNode = mounted ? document.body : null;

  if (renderedContent) {
    if (mounted) {
      return [createPortal(container(renderedContent), domNode), renderedChildren && cloneElement(renderedChildren, {
        key: 'portal-trigger'
      })];
    }

    return renderedChildren;
  } // The server needs to render a placeholder element here or else you get chaos!


  return React.createElement("div", null, mounted && createPortal(container(renderedChildren), domNode));
}
Modal.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.func]),
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.func]),
  forceIsShowing: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func
};
Modal.defaultProps = {
  children: null,
  content: undefined,
  forceIsShowing: false,
  onOpen: function onOpen() {},
  onClose: function onClose() {}
};